module.exports = new __parcel__URL__("light-mode.e7c3914f.svg").toString();